import {Questionary} from "../../../../model/questionary";
import {ComboItem} from "../../../../model/items/combo";
import {LabelItem} from "../../../../model/items/labelItem";
import m, {Vnode} from "mithril";
import {ImageItem} from "../../../../model/items/imageItem";

export default class DragCell {

    private readonly questionary: Questionary;

    constructor(
        public readonly combo: ComboItem,
        private readonly label?: LabelItem,
		private readonly image?: ImageItem
    ) {
        this.questionary = combo.cell.grid.questionary;
    }

    public view(): Vnode {
        return m('.dragCell', {
            "data-id": this.combo.variableName,
        }, [
            m('.handle', {}, [
                m('i.icon.icon-drag-handle.accent', {}, ''),
            ]),
            this.image?.getView() ?? null,
			this.label ? m('.label', {}, this.questionary.renderText(this.label.childrenTags[0]?.value??'')) : null,
        ]);
    }

}
